import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M7.5 6.624v10.752L15.863 12 7.5 6.624zm-.344-2.005l10.5 6.75a.75.75 0 010 1.262l-10.5 6.75A.75.75 0 016 18.751V5.25a.75.75 0 011.156-.631z" fill="currentColor" /></svg>;
}
export default SvgComponent;